var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['c-toasts__item', 'c-toasts__item--' + _vm.toast.type, _vm.hasEvents],on:{"click":_vm.handleClick}},[(_vm.typeIcon)?_c('svg',{class:['icon', _vm.typeIcon]},[_c('use',{attrs:{"xlink:href":'#' + _vm.typeIcon}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"c-toasts__item-text"},[_vm._v(_vm._s(_vm.toast.text))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f732c8c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/app/plugins/toasts/Toast.vue
// module id = 265
// module chunks = 65